import { jsx as C } from "react/jsx-runtime";
function o(e) {
  return /* @__PURE__ */ C("svg", { fill: "none", height: "1em", viewBox: "0 0 24 24", width: "1em", ...e, children: /* @__PURE__ */ C(
    "path",
    {
      d: "M13.4141 12L20.7071 4.707C21.0977 4.3164 21.0977 3.6836 20.7071 3.2929C20.3165 2.9022 19.6837 2.9023 19.293 3.2929L12 10.5859L4.707 3.293C4.3164 2.9024 3.6836 2.9024 3.2929 3.293C2.9022 3.6836 2.9023 4.3164 3.2929 4.7071L10.5859 12.0001L3.2929 19.2931C2.9023 19.6837 2.9023 20.3165 3.2929 20.7072C3.4882 20.9025 3.7441 21.0002 3.9999 21.0002C4.2557 21.0002 4.5116 20.9025 4.7069 20.7072L11.9999 13.4142L19.2929 20.7072C19.4882 20.9025 19.7441 21.0002 19.9999 21.0002C20.2557 21.0002 20.5116 20.9025 20.7069 20.7072C21.0975 20.3166 21.0975 19.6838 20.7069 19.2931L13.4141 12Z",
      fill: "currentColor"
    }
  ) });
}
export {
  o as default
};
